import { Box } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import DescriptionIcon from '@material-ui/icons/Description';
import NoteIcon from '@material-ui/icons/Note';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { GET_NEWS, NEWS_ARTICLES } from '../../../../constants/api';
import { IconButton } from 'components/AORedesign';
import { handleFileDownload } from '../../../CommonUtilityServices/DownloadFileService';
import { handlePdfDownload } from '../../../CommonUtilityServices/DownloadPdfService';

const SearchNewsArticlesTypeRenderCell = ({ type, extension, seqId, handleOpenForNewsReview }) => {
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [, setDownloadingPdfError] = useState(false);
  const [, setIsDownloadingFileErrorVisible] = useState(false);
  const [, setDownloadingFileError] = useState(false);
  const [, setLoadingFile] = useState(false);

  const handleClickPdfDownload = (id) => {
    handlePdfDownload('GET', null, `${NEWS_ARTICLES}/${id}`, setLoadingPdf, setDownloadingPdfError, setDownloadingPdfError, 'newWindow', `${GET_NEWS}`);
  };
  const handleClickFileDownload = (id) => {
    handleFileDownload(
      `${NEWS_ARTICLES}/${id}`,
      setLoadingFile,
      setDownloadingFileError,
      setIsDownloadingFileErrorVisible,
      'newWindow',
      'GET',
      undefined,
      GET_NEWS,
    );
  };

  if (loadingPdf)
    return (
      <Box py={2}>
        <CircularProgress color="inherit" size={20} />
      </Box>
    );

  const renderIcon = () => {
    if (type === 'T') {
      return (
        <IconButton id={`news-article-review-${seqId}`} aria-label="Review news article" onClick={handleOpenForNewsReview}>
          <NoteIcon />
        </IconButton>
      );
    } else if (type === 'D' && extension === 'doc') {
      return (
        <IconButton id={`news-article-download-doc-${seqId}`} aria-label="Download document" onClick={() => handleClickFileDownload(seqId)}>
          <DescriptionIcon />
        </IconButton>
      );
    } else if (type === 'D' && extension === 'pdf') {
      return (
        <IconButton id={`news-article-download-pdf-${seqId}`} aria-label="Download PDF" onClick={() => handleClickPdfDownload(seqId)}>
          <PictureAsPdfIcon />
        </IconButton>
      );
    } else {
      return (
        <IconButton id={`news-article-note-${seqId}`} aria-label="Note">
          <NoteIcon />
        </IconButton>
      );
    }
  };

  return renderIcon();
};

SearchNewsArticlesTypeRenderCell.propTypes = {
  type: PropTypes.string,
  extension: PropTypes.string,
  seqId: PropTypes.number,
  handleOpenForNewsReview: PropTypes.func,
};

export default SearchNewsArticlesTypeRenderCell;
